import { DesktopShell } from '@/components/dashboard/DashboardShell';
import { BusRoutesContent } from '@/components/dashboard/BusRoutesContent';

export default function BusSchedulesDesktop() {
  return <BusRoutesContent Shell={DesktopShell} mode="desktop" />;
}
